import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import OneVisualLayout from "../../layouts/one-visual";
import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';

import styled from 'styled-components';

const FormulaName = styled.div`
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: #ffffff;

  ${p => p.background && `
    background-color: ${p.background};
  `}

  ${p => p.padding && `
    padding: ${p.padding};
  `}

  ${p => p.color && `
    color: ${p.color};
  `}
`;

const FormulaValue = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.fontSize && `
    font-size: ${p.fontSize};
  `}

  ${p => p.isNegative && `
    color: #EC5E59;
  `}

  span.divider {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 27, 59, 0.94);
    margin: 13px 0 13px -5px;
    width: calc(100% + 10px);
  }

  b, .negative-value {
    color: #EC5E59;
  }
`;

class ResultsAreInStep1 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      teamFinancialsEndingCash: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound } = this.props;
    const teamId = Auth.getTeamId();

    getRequest([
      `${process.env.REACT_APP_API_URL}team/page/financials/?round_number=${activeRound}&team_id=${teamId}`
    ])
      .then(res => {
        const teamFinancialsEndingCash = res.body.team.ending_cash;

        this.setState({
          loaded: true,
          teamFinancialsEndingCash
        })
      })
      .catch(err => { });
  }

  render() {
    const { loaded, teamFinancialsEndingCash } = this.state;

    return loaded ? (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Insufficient Capital"
        paragraph2={(
          <Fragment>
            Your team did not have enough capital to cover your product, marketing, and/or operation spending decisions. Therefore some or all of your team decisions were not accepted.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <Fragment>
              <FormulaName background="#4CC7D1" color="rgba(0, 27, 59, 0.94)">
                Insufficient Capital
              </FormulaName>
              <FormulaValue fontSize="28px">=</FormulaValue>
              <FormulaValue fontSize="40px" isNegative={teamFinancialsEndingCash < 0}>
                {teamFinancialsEndingCash.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 0,
                })}
              </FormulaValue>
            </Fragment>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#D7F0F2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default ResultsAreInStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step1.js